var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue, Emit } from 'vue-property-decorator';
let AdminFiltersHeaderMenu = class AdminFiltersHeaderMenu extends Vue {
    constructor() {
        super(...arguments);
        this.filterGroup = [
            {
                label: 'Status do Usuário',
                items: [
                    {
                        key: 'user_status',
                        label: 'Habilitado',
                        value: 'active',
                        isSelected: false,
                    },
                    {
                        key: 'user_status',
                        label: 'Desabilitado',
                        value: 'inactive',
                        isSelected: false,
                    },
                ],
            },
            {
                label: 'Tipo da Conta',
                items: [
                    {
                        key: 'account_status',
                        label: 'Cliente com contrato ativo',
                        value: 'active',
                        isSelected: false,
                    },
                    {
                        key: 'account_status',
                        label: 'Cliente suspenso',
                        value: 'suspended',
                        isSelected: false,
                    },
                    {
                        key: 'account_status',
                        label: 'Cliente em migração',
                        value: 'migrated',
                        isSelected: false,
                    },
                    {
                        key: 'account_status',
                        label: 'Teste',
                        value: 'free',
                        isSelected: false,
                    },
                    {
                        key: 'account_status',
                        label: 'Indefinido',
                        value: 'undefined',
                        isSelected: false,
                    },
                ],
            },
            {
                label: 'Tipo do Usuário',
                items: [
                    { key: 'type_user', label: 'Admin', value: 'admin', isSelected: false },
                    { key: 'type_user', label: 'Owner', value: 'owner', isSelected: false },
                    {
                        key: 'type_user',
                        label: 'Prospector',
                        value: 'prospector',
                        isSelected: false,
                    },
                    {
                        key: 'type_user',
                        label: 'Coordenador',
                        value: 'coordinator',
                        isSelected: false,
                    },
                    {
                        key: 'type_user',
                        label: 'Manager',
                        value: 'manager',
                        isSelected: false,
                    },
                ],
            },
        ];
    }
    searchUsersCheckboxFilters() {
        return this.filterGroup;
    }
    resetFilters() {
        this.filterGroup.forEach(element => {
            element.items.forEach(item => {
                item.isSelected = false;
            });
        });
        return this.filterGroup;
    }
};
__decorate([
    Emit('searchUsersCheckboxFilters')
], AdminFiltersHeaderMenu.prototype, "searchUsersCheckboxFilters", null);
__decorate([
    Emit('resetFilters')
], AdminFiltersHeaderMenu.prototype, "resetFilters", null);
AdminFiltersHeaderMenu = __decorate([
    Component({
        name: 'AdminFiltersHeaderMenu',
    })
], AdminFiltersHeaderMenu);
export default AdminFiltersHeaderMenu;
